import React, { FC, useEffect, useState } from "react";
import { Input, Button, Modal, Row, Col, Spin, Avatar, List, Checkbox, Badge, Dropdown, Radio } from "antd";
import _ from "lodash";

import { DeleteOutlined, HomeOutlined, LockOutlined, SettingOutlined, UserOutlined } from "@ant-design/icons";
import { getRole } from "utils/chatUtils";
import {
    wrapRequestPayload,
    getMessageRequestPayload,
} from "../../helpers/request/RequestPayload";
import useLocalStorageService from "../../services/localStorage";
import { SocketTopics } from "../../constants/enums";
import { CID, UUID, RID } from "../../constants/localStoreKeys";
import {
    getModifyPageSubscriptionTopic,
} from "hooks/MQTTConstants";
import { UserRoles } from "utils/appUtil";
import { ReactSVG } from "react-svg";
import MembersPopup from "./MembersPopup";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "reducers/rootReducer";
import {
    GET_PAGE,
    GET_USERS_LIST,
    GET_ALL_FRIEND_PAGE,
    GET_ADMIN_GROUPS,
    GET_ADMIN_GROUP_MEMBERS,
} from "reducers/authReducer";

const PageAvatarItem: FC<{
    onMarkChange?: (user: any, e: any) => void,
    remove?: () => void
    data: any,
    selectedItem?: SelectedSearchItem,
    index?: number
    allUsers: any[],
    isSelect?: boolean,
    isDelete?: boolean,
    showMembers?: boolean,
    socket?: ISocket,
    title: string,
    isGroup?: boolean
}> = ({
    data,
    selectedItem,
    allUsers,
    onMarkChange,
    index,
    isSelect,
    isDelete,
    remove,
    showMembers,
    socket,
    title,
    isGroup
}) => {
        const { adminRoles } = useSelector((state: RootState) => state.dashboard);
        const [isMembersLoading, setIsMembersLoading] = useState(false);
        const [groupMembersList, setGroupMembersList] = useState({});

        const dispatch = useDispatch();

        return (
            <Row style={{ clear: "both" }} className="person-item" key={index}>
                <Col span={5}>
                    <ReactSVG
                        src={`/images/community-blue-icon.svg`}
                        className="colorable mark-icon"
                    />
                </Col>
                <Col span={12}>
                    <h5>{title}</h5>
                </Col>
                <Col span={7} className="t-right">
                    {selectedItem &&
                        selectedItem.currentUserRole === "edit" && (
                            <React.Fragment>
                                {isDelete && (<Button
                                    className="beam-btn mr-1 button orange-btn no-shadow cover"
                                    onClick={() => remove()}
                                >
                                    <DeleteOutlined className="text-white" />
                                </Button>)}
                                {isSelect && (<Checkbox checked={data.marked} onChange={(e) => onMarkChange(data, e)} className="circular-checkbox">
                                    <span className="checkmark"></span>
                                </Checkbox>)}
                                {showMembers && !isGroup && (<Dropdown
                                    trigger={["click"]}
                                    overlay={<MembersPopup
                                        adminRoles={adminRoles}
                                        allUsers={allUsers}
                                        isMembersLoading={isMembersLoading}
                                        users={data.members}
                                    ></MembersPopup>}
                                    className="message-dropdown"
                                    placement="bottomRight"
                                >
                                    <a
                                        className="ant-dropdown-link"
                                        onClick={(e) => e.preventDefault()}
                                    >
                                        <Button className="beam-btn"><UserOutlined /></Button>
                                    </a>
                                </Dropdown>)}
                                {showMembers && isGroup && (<Dropdown
                                    trigger={["click"]}
                                    onVisibleChange={(visible) => {
                                        if (visible) {
                                            const queryId =
                                                data.objectId.toString();
                                            if (queryId) {
                                                setIsMembersLoading(true);
                                                dispatch(
                                                    GET_ADMIN_GROUP_MEMBERS({
                                                        queryId,
                                                        callback: (response) => {
                                                            const members = {};
                                                            response?.data?.list.map(
                                                                (user) => {
                                                                    if (user.split(":")?.[1] === 'user') {
                                                                        members[user.split(":")?.[2]] = {};
                                                                    }
                                                                    return user;
                                                                }
                                                            );
                                                            setGroupMembersList({
                                                                ...groupMembersList,
                                                                [data.objectId.toString()]:
                                                                    members,
                                                            });
                                                            setIsMembersLoading(false);
                                                        },
                                                    })
                                                );
                                            }
                                        }
                                    }}
                                    overlay={<MembersPopup
                                        adminRoles={adminRoles}
                                        allUsers={allUsers}
                                        isMembersLoading={isMembersLoading}
                                        users={
                                            groupMembersList?.[
                                            data.objectId.toString()
                                            ]
                                        }
                                    ></MembersPopup>}
                                    className="message-dropdown"
                                    placement="bottomRight"
                                >
                                    <a
                                        className="ant-dropdown-link"
                                        onClick={(e) => e.preventDefault()}
                                    >
                                        <Button className="beam-btn"><UserOutlined /></Button>
                                    </a>
                                </Dropdown>)}
                            </React.Fragment>
                        )}
                </Col>
            </Row>
        );
    };

export default PageAvatarItem;
